<template>
  <div class="menu">
    <ul class="nav">
      <template v-for="(item, i) in $parent.nav">
        <li
          class="nav__item"
          :key="i"
          v-if="item.link != '/privacy' && item.link != '/terms'"
        >
          <router-link :to="item.link">
            <span v-if="item.title == 'New Arrivals'">New</span>
            <template v-if="item.title == 'New Arrivals'"> Arrivals </template>
            <template v-else>
              {{ item.title != "Sale" ? item.title : "" }}
            </template>
            <span class="red" v-if="item.title == 'Sale'">Sale</span>
          </router-link>
        </li>
      </template>
      <!-- <div class="nav__item" v-if="$route.name == 'Profile'  || $route.name == 'SellOffers'">
			<a @click="$emit('openSaleSkinModal')">Sale your skin</a>
			</div> -->
    </ul>
    <div v-if="$parent.isAuth" class="cash">
      <img src="./../assets/wallet.svg" class="img" />
      <div class="desc">
        {{ balance }}
        <span class="currency">
          <img src="./../assets/coin.svg" class="img" />
        </span>
      </div>
      <button class="desc" @click="$parent.openTopup">
        <img src="./../assets/plus.svg" class="img" />
      </button>
    </div>
  </div>
</template>

<script>
/*import Vue from 'vue';
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)*/
export default {
  name: "Menu",
  props: [],
  data: function () {
    return {
      balance: "0.00",
    };
  },
  watch: {
    isAuth() {
      this.getBalance();
    },
    appBalance() {
      this.getBalance();
    },
  },
  mounted() {
    this.curr = this.currencyCode;
    this.getBalance();
  },
  methods: {
    getBalance() {
      if (this.$parent.isAuth) {
        this.$http.get(process.env.VUE_APP_API + "user/profile").then((res) => {
          this.balance = res.data.balance;
        });
      }
    },
  },
};
</script>
